import React, { useCallback } from "react";
import { EntryModel, WorkspaceData } from "lib/models";
import { updateEntry } from "lib/api";
import EditableTitle from "components/EditableTitle";
import EntryCountBadge from "./EntryCountBadge";
import EntryContentContainer from "components/MoveableEntry/EntryContentContainer";

interface WorkspaceEntryProps {
  entryRefId: string;
  model: EntryModel<WorkspaceData>;
}

function WorkspaceEntry({ entryRefId, model }: WorkspaceEntryProps) {
  const saveName = useCallback(async (title: string = ""): Promise<void> => {
    const updatePatch: Partial<WorkspaceData> = { name: title };
    await updateEntry(model.uuid, model.data.type, updatePatch);
  }, []);

  return (
    <div className="flex flex-col w-full h-full bg-palette-2 rounded-lg p-2 relative">
      <EntryContentContainer>
        <EditableTitle
          initialText={model.data.name || "Unnamed Workspace"}
          onTitleChange={saveName}
        />
      </EntryContentContainer>
      <div className="absolute bottom-2 right-2">
        <EntryCountBadge
          count={Object.values(model.data.entryRefs).length}
        ></EntryCountBadge>
      </div>
    </div>
  );
}

export default WorkspaceEntry;
